import {
  ConnectionDetails,
  HandleErrorInput,
  convertConnectionToDetails,
  handleError,
  mergeConnectionDetails as merge,
} from '@/utils/custom';
import { ConnectionOptions, GraphApiMethod } from '@/api/core';
import { Fcr, FcrSearch, SearchFcrTypeResponseFcrTypeConnectionArgs } from '@/models/gen/graphql';
import createGraphApiHook, { CreateGraphApiHookHook } from '@/hooks/createGraphApiHook';

import { SearchFcrsDocument } from '@/api/queries';
import { TypedDocumentNode } from '@apollo/client';
import { getProperty } from '@/utils';
import graphApi from '@/api';

// Global Service Variables
const mergeKey = 'searchFcrs.fcrConnection';
const onError = (res: HandleErrorInput): void => handleError(res, { notification: { title: 'Search Complaints' } });

// Service Function Signature
type ServiceMethodPayload = {
  [key in keyof FcrSearch]?: any;
}[];
interface ServiceMethod {
  (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<ConnectionDetails<Fcr>>;
}

// SearchFcrType Service
export const { searchFcrs, refetchFcrs, useSearchFcrs } = ((): {
  searchFcrs: ServiceMethod;
  refetchFcrs: ServiceMethod;
  useSearchFcrs: CreateGraphApiHookHook<ServiceMethod>;
} => {
  const [fetch, refetch] = graphApi(SearchFcrsDocument, {
    onError,
  }).map(
    (fn: GraphApiMethod<TypedDocumentNode>): ServiceMethod =>
      async (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<ConnectionDetails<Fcr>> => {
        const args: SearchFcrTypeResponseFcrTypeConnectionArgs = {
          input: {
            first: options?.pageSize || null,
            after: options?.pageSize > 0 ? (options?.pageSize * options?.page).toString() : null,
            query: payload,
          },
        };
        const opts = { merge: options?.merge ? mergeKey : undefined };
        const res = await fn(args, opts);
        return convertConnectionToDetails(getProperty(mergeKey, res));
      }
  );
  const useService = createGraphApiHook(fetch, { refetch, merge });
  return {
    searchFcrs: fetch,
    refetchFcrs: refetch,
    useSearchFcrs: useService,
  };
})();
